import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from "../../../../context/builder/reducers";
import arrayMove from 'array-move';
import SortableList, { DIRECTION_ACTIVITY_ITEM } from '../SortableList';

const defaultElements = [
    { title: '', img: '', link: '' },
    { title: '', img: '', link: '' },
    { title: '', img: '', link: '' },
    { title: '', img: '', link: '' },
]

const ItemList = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '',
                elements: [...defaultElements]
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    let elements = props.content.elements || [...defaultElements];

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const data = state.data;
        elements = arrayMove(elements, oldIndex, newIndex);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        elements.splice(index, 1);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <SortableList
            item={DIRECTION_ACTIVITY_ITEM}
            titleComponent="Direction activity"
            title={props.content.title || ''}
            type={props.type}
            elements={elements}
            onChange={onChange}
            onSortEnd={onSortEnd}
            deleteButtonHandler={deleteButtonHandler}
            axis="xy"
            useDragHandle
        />);
}

export default ItemList;
